// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGSearch = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 31 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.139 17.893c-3.725 0-6.755-3.03-6.755-6.754 0-3.724 3.03-6.755 6.755-6.755 3.724 0 6.754 3.03 6.754 6.755 0 3.724-3.03 6.754-6.754 6.754m0-15.893c5.039 0 9.137 4.1 9.137 9.14 0 2.09-.705 4.018-1.89 5.56l7.265 7.265c.465.466.465 1.22 0 1.686-.466.465-1.22.465-1.686 0L18.7 18.385c-1.542 1.186-3.47 1.891-5.561 1.891C8.099 20.276 4 16.178 4 11.14 4 6.1 8.1 2 13.139 2z",
      id: "search__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#search__a",
    fillRule: "evenodd"
  })]
}));
SVGSearch.displayName = 'SVGSearch';
export default SVGSearch;